/* rk-video-controls.js (r55, 16 Oct 2026). Pause / play and sound buttons on EVERY video (Alexander: "I can't see where I can pause them, or unmute
   them. This should be functionality for all videos on the website").
   - One small control group in the bottom-right corner of each video: [sound] [pause]. 44px tap targets, 2px squares (DESIGN 2), white thin-line icons.
     Narrow tiles (under 200px wide, e.g. the About page clips) stack the two buttons.
   - The sound button only appears when the clip has an audio track (mozHasAudio / audioTracks / webkitAudioDecodedByteCount).
   - A paused clip stays paused: bf26-core.js does not restart a clip whose __bfUserPaused is set. Sound on: __bfSound lets bf26-core.js keep it unmuted,
     and every other video is muted (one sound at a time). Scrolling away still pauses the clip (bf26-core.js), as before.
   - Customer-review videos keep their own controls (assets/bf26-video-review.js, same look). Opt out: data-rk-no-vc on the video or a wrapper.
   Styles: assets/rk-system.css section 26. Rollback: remove the script tag in snippets/bf26z-sitewide.liquid. */
(function () {
  'use strict';
  if (window.__rkvc) return;
  window.__rkvc = 1;
  var ICO = {
    pause: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" aria-hidden="true" focusable="false"><path d="M9 6v12M15 6v12"/></svg>',
    play: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M8 5.5v13l10.5-6.5z"/></svg>',
    off: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M16 10l4 4M20 10l-4 4"/></svg>',
    on: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.75" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false"><path d="M4 9.5h3.5L12 6v12l-4.5-3.5H4z"/><path d="M15.5 9.5a3.5 3.5 0 0 1 0 5M18 7a7 7 0 0 1 0 10"/></svg>'
  };
  var noop = function () {};
  function skip(v) {
    if (v.controls || v.closest('[data-rk-no-vc], [data-bf-allow-controls], header, cart-drawer, dialog')) return true;
    var BF = window.BF26;
    return !!(BF && BF.isRev && BF.isRev(v)); /* review videos: bf26-video-review.js */
  }
  function hostOf(v) { return v.closest('internal-video') || v.parentElement; }
  function audio(v) {
    if (typeof v.mozHasAudio === 'boolean') return v.readyState >= 1 ? v.mozHasAudio : null;
    if (v.audioTracks && typeof v.audioTracks.length === 'number') return v.readyState >= 1 ? v.audioTracks.length > 0 : null;
    if (typeof v.webkitAudioDecodedByteCount === 'number') {
      if (v.webkitAudioDecodedByteCount > 0) return true;
      return v.currentTime > 1.5 ? false : null;
    }
    return true; /* no way to tell: offer the button */
  }
  function play(v) { var p; try { p = v.play(); } catch (e) {} if (p && p.catch) p.catch(noop); }
  function btn(cls) {
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'rk-vc__b ' + cls;
    return b;
  }
  function setup(v) {
    if (v.__rkvc || skip(v)) return;
    var host = hostOf(v);
    if (!host) return;
    v.__rkvc = 1;
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';
    var box = document.createElement('div'); box.className = 'rk-vc'; box.hidden = true; v.__rkBox = box;
    var snd = btn('rk-vc__snd'), pz = btn('rk-vc__pz');
    snd.hidden = true;
    box.appendChild(snd); box.appendChild(pz);
    host.appendChild(box);
    function sync() {
      var paused = v.paused;
      pz.innerHTML = paused ? ICO.play : ICO.pause;
      pz.setAttribute('aria-label', paused ? 'Play video' : 'Pause video');
      snd.innerHTML = v.muted ? ICO.off : ICO.on;
      snd.setAttribute('aria-label', v.muted ? 'Turn sound on' : 'Turn sound off');
      snd.setAttribute('aria-pressed', v.muted ? 'false' : 'true');
    }
    var mount = host, lifted = false;
    function place() {
      /* when the box sits in another element than the video's own wrapper, line it up with the video's bottom-right corner */
      if (mount === host) return;
      var r = v.getBoundingClientRect(), m = mount.getBoundingClientRect();
      box.style.right = Math.round(m.right - r.right + 6) + 'px';
      box.style.bottom = Math.round(m.bottom - r.bottom + 6) + 'px';
    }
    function lift() {
      /* a section's own overlay (e.g. the hero text layer) can sit on top of the video and swallow the taps: move the box up to the
         nearest element that holds both, so it is painted above that overlay. Overlays from outside the section (cookie banner, sticky bar) are ignored. */
      if (lifted || box.hidden) return;
      var b = pz.getBoundingClientRect();
      if (!b.width || b.bottom < 0 || b.top > (window.innerHeight || 800)) return;
      var hit = document.elementFromPoint(b.left + b.width / 2, b.top + b.height / 2);
      if (!hit || box.contains(hit)) return; /* not covered (yet): look again later, overlays can fade in after load */
      var sec = v.closest('.shopify-section') || document.body;
      if (!sec.contains(hit)) return;
      var a = host.parentElement;
      while (a && a !== sec && !a.contains(hit)) a = a.parentElement;
      if (!a || !a.contains(hit)) return;
      if (getComputedStyle(a).position === 'static') a.style.position = 'relative';
      lifted = true; mount = a; box.style.zIndex = '20'; a.appendChild(box); place();
    }
    function size() {
      var r = v.getBoundingClientRect();
      var shown = r.width > 0 && r.height > 0;
      if (box.hidden === shown) box.hidden = !shown;
      box.classList.toggle('rk-vc--col', shown && r.width < 200);
      place();
      if (shown) requestAnimationFrame(lift);
    }
    function detect() {
      if (!snd.hidden) return;
      var a = audio(v);
      if (a === true) { snd.hidden = false; off(); }
      else if (a === false) off();
    }
    function off() { ['loadedmetadata', 'loadeddata', 'playing', 'timeupdate'].forEach(function (ev) { v.removeEventListener(ev, detect); }); }
    ['loadedmetadata', 'loadeddata', 'playing', 'timeupdate'].forEach(function (ev) { v.addEventListener(ev, detect); });
    pz.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (v.paused) { v.__bfUserPaused = false; play(v); }
      else { v.__bfUserPaused = true; v.pause(); }
      sync();
    });
    snd.addEventListener('click', function (e) {
      e.preventDefault(); e.stopPropagation();
      if (v.muted) {
        document.querySelectorAll('video').forEach(function (o) { if (o !== v && !o.muted) { o.__bfSound = false; o.muted = true; } });
        v.__bfSound = true; v.muted = false;
        if (v.paused) { v.__bfUserPaused = false; play(v); }
      } else { v.__bfSound = false; v.muted = true; }
      sync();
    });
    ['play', 'pause', 'volumechange', 'loadeddata'].forEach(function (ev) { v.addEventListener(ev, sync); });
    try { new ResizeObserver(size).observe(v); } catch (e) { window.addEventListener('resize', size); }
    try { new IntersectionObserver(function (en) { if (en[0] && en[0].isIntersecting) { place(); requestAnimationFrame(lift); [1200, 3500].forEach(function (d) { setTimeout(lift, d); }); } }).observe(v); } catch (e) {}
    v.addEventListener('playing', function () { requestAnimationFrame(lift); });
    size(); sync(); detect();
  }
  /* 25 Oct 2026 (speed): set up in idle time; it measured every video while the page was still building */
  var scanQ = false;
  function scan() {
    if (scanQ) return; scanQ = true;
    (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(function () {
      scanQ = false;
      var vs = document.querySelectorAll('video');
      for (var i = 0; i < vs.length; i++) if (!vs[i].__rkvc) setup(vs[i]);
    }, { timeout: 1500 });
  }
  function boot() {
    scan();
    if (window.BF26 && window.BF26.watch) window.BF26.watch(scan);
    else { try { new MutationObserver(scan).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {} }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
